module.exports = __webpack_public_path__ + "img/37.605d92c0.jpg";